import LiveChat from './LiveChat';

export default LiveChat;
